import { ooFetchWithResponse } from './ooFetchWithResponse';

let catalogApi = {
    addToRecipe: async(recipeName, itemID, numServings) => {
        let url = 'catalog/v1/recipes/' + recipeName + '/add';
        let body = JSON.stringify({itemID: itemID, numServings: numServings});
        let response = await ooFetchWithResponse(url, { method: "PUT", body: body });
        return response;
    },
    createItem: async (params) => {
        let url = 'catalog/v1';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    createRecipe: async (params) => {
        let url = 'catalog/v1/recipe';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    getItemDetails: async (itemID) => {
        let url = 'catalog/v1/details?itemID=' + itemID;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getItems: async () => {
        let url = 'catalog/v1';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getRecipeDetails: async (id) => {
        let url = 'catalog/v1/recipes/' + id;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getRecipes: async () => {
        let url = 'catalog/v1/recipes';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getSandwichItems: async () => {
        let url = 'catalog/v1/sandwichItems';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    removeFromRecipe: async(recipeName, itemID) => {
        let url = 'catalog/v1/recipes/' + recipeName + '/remove';
        let body = JSON.stringify({itemID: itemID});
        let response = await ooFetchWithResponse(url, { method: "PUT", body: body });
        return response;
    },
    updateItem: async (itemID, params) => {
        let url = 'catalog/v1/item/' + itemID;
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "PUT", body: body });
        return response;
    },
}

export { catalogApi };